import { contactConnectedDate, type Contact } from "./domain";

export type PeopleSortKey = "person" | "sources" | "connected";
export type SortDirection = "asc" | "desc";

const sourceLabels: Record<string, string> = { camcard: "CamCard", linkedin: "LinkedIn", camera: "Camera" };
const sourceOrder = ["camcard", "linkedin", "camera"];

export function sortPeopleContacts(contacts: Contact[], key: PeopleSortKey, direction: SortDirection) {
  return [...contacts].sort((left, right) => {
    const nameOrder = left.displayName.localeCompare(right.displayName, "en", { sensitivity: "base" });
    if (key === "person") return direction === "asc" ? nameOrder : -nameOrder;
    if (key === "connected") {
      const leftDate = contactConnectedDate(left)?.getTime(); const rightDate = contactConnectedDate(right)?.getTime();
      if (leftDate == null && rightDate == null) return nameOrder;
      if (leftDate == null) return 1; if (rightDate == null) return -1;
      return direction === "asc" ? leftDate - rightDate || nameOrder : rightDate - leftDate || nameOrder;
    }
    const leftSources = sourceSortValue(left), rightSources = sourceSortValue(right);
    if (!leftSources && !rightSources) return nameOrder;
    if (!leftSources) return 1; if (!rightSources) return -1;
    const sourceComparison = leftSources.localeCompare(rightSources, "en", { sensitivity: "base" });
    return direction === "asc" ? sourceComparison || nameOrder : -sourceComparison || nameOrder;
  });
}

function sourceSortValue(contact: Contact) { return sourceOrder.filter((value) => contact.sources.includes(value)).map((value) => sourceLabels[value]).join(" · "); }
